import { useEffect } from "react";

// This page is opened by Inicis inside the payment popup to close it.
// It must exist at /close on the same domain as your payment page.
const ClosePage = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://stgstdpay.inicis.com/stdjs/INIStdPay_close.js";
    // For production: "https://stdpay.inicis.com/stdjs/INIStdPay_close.js"
    script.charset = "UTF-8";
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default ClosePage;